import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import { primaryOpaque, primary } from '../assets/colors.js';
import golfCourseImg from '../assets/img/golfCourse.jpg.js';

var _templateObject, _templateObject2;
var ContentFrame = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  height: 400px;\n  background-position: center;\n  background: url(", ");\n  background-size: cover;\n  box-shadow: 0 5px 10px 0;\n  margin-top: 30px;\n"])), function (props) {
  return props.img;
});
var TextFrame = styled.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  color: white;\n  padding-top: 30px;\n  background: linear-gradient(to top, ", " 0%, ", " 80%);\n"])), primaryOpaque, primary);
var ComingSoon = (function () {
  return /*#__PURE__*/React__default.createElement(ContentFrame, {
    img: golfCourseImg
  }, /*#__PURE__*/React__default.createElement(TextFrame, {
    className: "text-center"
  }, "Coming Soon!"));
});

export { ComingSoon as default };
